export default __webpack_public_path__ + "static/media/grubtech.cd0fafc5.png";